import { useMemo } from 'react';
import { DomainEntityConfiguration } from '@web-config-app/core';
import { useConfigApp } from '../use-config-app/use-config-app';

/**
 * Retrieves an entity configuration based on the passed type.
 */

export const useEntityReference = ({ entityType }: { entityType: string }) => {
  const { entityConfigs } = useConfigApp();

  if (!entityType) {
    throw new Error(`useEntityReference: entityType is required`);
  }

  const entityConfig = useMemo(() => {
    const entityFromType = Object.values(entityConfigs).find(
      (entity: DomainEntityConfiguration) => entity?.type === entityType,
    );

    if (!entityFromType) {
      throw new Error(`Unknown entity type: ${entityType}`);
    }

    return entityFromType;
  }, [entityType, entityConfigs]);

  return entityConfig;
};
